<template>
    <div class="relative group">
        <Listbox
            as="div"
            class="space-y-1"
            v-model="model"
            v-slot="{ open }"
            :disabled="disabled">
            <div class="relative">
                <div class="block w-full rounded-md shadow-sm">
                    <ListboxButton
                        ref="button"
                        class="cursor-default group relative w-full rounded-full border bg-white pl-3 pr-10 py-2 text-left focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150"
                        :class="[
                            hasError ? 'border-red-500' : 'border-gray-300',
                            disabled ? 'opacity-50 cursor-not-allowed' : ''
                        ]">

                        <div class="block truncate">
                            <span v-if="hasValue">{{ model.label }}</span>
                            <span v-else-if="placeholder" class="text-gray-400">{{ placeholder }}</span>
                            <span v-else>&nbsp;</span>
                        </div>

                        <div
                            :class="{'group-hover:hidden': hasValue && clearable}"
                            class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none z-10">
                            <svg
                                class="h-5 w-5 text-gray-400"
                                viewBox="0 0 20 20"
                                fill="none"
                                stroke="currentColor">
                                <path
                                    d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </ListboxButton>
                </div>
                <transition
                    leave-active-class="transition ease-in duration-100"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0">
                    <div
                        v-if="open"
                        class="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg">

                        <ListboxOptions
                            static
                            class="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none">

                            <ListboxOption
                                v-for="option in options"
                                :key="option.value"
                                :value="option"
                                v-slot="{ selected, active }">

                                <div
                                    class="cursor-default select-none relative py-2 pl-8 pr-4"
                                    :class="[active ? 'text-white bg-blue-600' : 'text-gray-900']">
                                    <div
                                        class="block truncate"
                                        :class="[selected ? 'font-semibold' : 'font-normal']">
                                        {{ option.label }}
                                    </div>
                                    <div
                                        v-if="selected"
                                        class="absolute inset-y-0 left-0 flex items-center pl-1.5"
                                        :class="[active ? 'text-white' : 'text-blue-600']">
                                        <svg
                                            class="h-5 w-5"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor">
                                            <path
                                                fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </ListboxOption>
                        </ListboxOptions>
                    </div>
                </transition>
            </div>
        </Listbox>
        <div
            v-if="hasValue && clearable && !disabled"
            class="absolute inset-y-0 right-0 flex items-center pr-2 z-10">
            <button
                type="button"
                ref="clear"
                class="hidden cursor-pointer group-hover:inline-block absolute inset-y-0 right-0 w-5 mr-1 focus:outline-none"
                @click.prevent="clear">
                <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
            </button>
        </div>
    </div>
</template>


<script>

import {Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions} from "@headlessui/vue";
import FormInput from "@/Mixins/FormInput";
export default {

    mixins: [FormInput],

    props: {
        options: {
            type: Array,
            required: true
        },
        placeholder: String,
        label: String,
        clearable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions
    },

    methods: {
        mainElement() {
            return this.$refs.button.$el;
        },
        clear() {
            this.model = null
        }
    },

    computed: {
        hasValue() {
            return this.model !== null;
        },
        model: {
            get() {
                const value = this.options.find(item => item.value == this.modelValue)

                return value ? value : null;
            },
            set(option) {
                this.$emit('update:modelValue', option ? option.value : null);
            }
        }
    }
};

</script>

